import { styled } from "../../../stitches.config";
import { Box } from "../../primitives";

export const CardName = styled(Box, {
  fontSize: 14,
  display: "inline-block",
  width: 150,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontWeight: "bold",
});

export const SubTitle = styled(Box, {
  color: "#555",
  fontSize: 12,
  display: "inline-block",
  width: 150,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});
